import { request } from '../request'
// import { EventSourcePolyfill } from 'event-source-polyfill'
// API 接口定义
export const commonApi = {
  getNfcConfigItem (data) {
    return request.post('/nfcConfig/getConfig', data)
  },
  getQuestionList (data) {
    return request.post('/admin/platform/chat/getQuestion', data)
  },
  recordPvUv (data) {
    return request.post('/admin/platform/chat/recordPvUv', data)
  }
}

export async function streamPost (url, data, onMessage, onError, onComplete) {
  const abortController = new AbortController()

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      signal: abortController.signal
    })

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)

    const reader = response.body.getReader()
    const decoder = new TextDecoder()
    let buffer = ''

    while (true) {
      const {
        done,
        value
      } = await reader.read()
      if (done) {
        onComplete?.()
        break
      }

      // 累积数据块到缓冲区
      buffer += decoder.decode(value, { stream: true })

      // 处理缓冲区中的完整事件
      let eventEnd
      while ((eventEnd = buffer.indexOf('\n\n')) >= 0) {
        const eventData = buffer.slice(0, eventEnd)
        buffer = buffer.slice(eventEnd + 2) // 移除已处理的部分

        // 解析SSE格式
        const lines = eventData.split('\n')
        for (const line of lines) {
          if (line.startsWith('data:')) {
            const jsonStr = line.slice(5).trim()
            // 新增：[DONE] 标记处理
            if (jsonStr === '{"content":"[DONE]"}') {
              onComplete?.()
              return () => abortController.abort()
            }
            try {
              const data = JSON.parse(jsonStr) // 解析JSON
              onMessage(data)
            } catch (e) {
              console.error('Failed to parse JSON:', jsonStr)
            }
          }
        }
      }
    }
  } catch (err) {
    onError?.(err)
  }

  return () => abortController.abort()
}
